import { colors, Spacer } from '@spritz-finance/ui'
import styled, { css } from 'styled-components'
import ErrorMessage from '../../../../../../components/ErrorMessage/ErrorMessage'

const Prefix = styled.div`
    position: absolute;
    height: 48px;
    line-height: 48px;
    top: 5px;
    left: 12px;
    font-size: 28px;
    color: var(--text-secondary, ${colors.medGrey});
`

const AmountFieldWrapper = styled.div<{ error?: boolean }>`
    border: 1px solid var(--text-secondary, ${colors.medGrey});
    ${({ error }) =>
        error &&
        css`
            border: 1px solid var(--text-error, ${colors.orchid});
        `}
    border-radius: 6px;
    background: var(--background-secondary, #ffffff);
    padding: 6px 16px;
    position: relative;

    input {
        border: none;
    }

    & > div:nth-child(3) {
        display: none;
    }
`

export const PaymentInputWrapper: React.FC<{ error?: string | null }> = ({ children, error }) => {
    const hasError = !!error
    return (
        <>
            <AmountFieldWrapper error={hasError}>
                <Prefix>$</Prefix>
                {children}
            </AmountFieldWrapper>
            {hasError ? <ErrorMessage message={error} /> : <Spacer height={16} />}
        </>
    )
}
